"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hautLastResult = exports.hautBrandConfig = exports.formatHautApiResponse = exports.hautUploadImage = exports.hautResults = void 0;
exports.getSkinAnalysis = getSkinAnalysis;
exports.getSkinTone = getSkinTone;
const skin_processor_1 = require("./skin.processor");
Object.defineProperty(exports, "formatHautApiResponse", { enumerable: true, get: function () { return skin_processor_1.formatHautApiResponse; } });
const haut_api_1 = require("./haut.api");
Object.defineProperty(exports, "hautResults", { enumerable: true, get: function () { return haut_api_1.hautResults; } });
Object.defineProperty(exports, "hautUploadImage", { enumerable: true, get: function () { return haut_api_1.hautUploadImage; } });
Object.defineProperty(exports, "hautBrandConfig", { enumerable: true, get: function () { return haut_api_1.hautBrandConfig; } });
Object.defineProperty(exports, "hautLastResult", { enumerable: true, get: function () { return haut_api_1.hautLastResult; } });
const APP_NAME = {
    HAIR: 'HAIR',
    SKIN: 'SKIN',
};
const API_NAME = {
    HAUT: 'haut',
};
function getBase64Image(image) {
    return __awaiter(this, void 0, void 0, function* () {
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onloadend = function (e) {
                var _a, _b, _c;
                if ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.error) {
                    reject((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.error);
                }
                resolve((_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.result);
            };
            reader.readAsDataURL(image);
        });
    });
}
function getSkinAnalysis(image_1, isCameraImage_1, userMeta_1) {
    return __awaiter(this, arguments, void 0, function* (image, isCameraImage, userMeta, subjectId = '', skinApi, meta, apidetails, algorithms, requestTimeout, appAttributeScale, appRange, options) {
        let base64Image = image;
        if (!isCameraImage) {
            base64Image = yield getBase64Image(image);
        }
        try {
            if (skinApi === API_NAME.HAUT) {
                const { hautSkinAnalyser } = yield Promise.resolve().then(() => __importStar(require('./haut.api')));
                const hautSkinAnalyserResponse = yield hautSkinAnalyser(base64Image, userMeta, subjectId, APP_NAME.SKIN, meta, apidetails, algorithms, requestTimeout, options);
                let warnings = {};
                warnings = hautSkinAnalyserResponse['result']['results']['warnings'];
                const formattedresult = (0, skin_processor_1.formatHautApiResponse)(hautSkinAnalyserResponse.result, algorithms, skinApi, appRange, appAttributeScale);
                return { result: formattedresult, imageUploadResponse: hautSkinAnalyserResponse.imageUploadResponse, warnings };
            }
        }
        catch (error) {
            if (error === null || error === void 0 ? void 0 : error.response) {
                throw error === null || error === void 0 ? void 0 : error.response;
            }
            else {
                throw error;
            }
        }
    });
}
function getSkinTone(ITAvalue) {
    const val = Number(ITAvalue.substring(4));
    if (val > 60 && val <= 90) {
        return '#f3e2de';
    }
    else if (val > 50 && val <= 60) {
        return '#fed1b4';
    }
    else if (val > 40 && val <= 50) {
        return '#fbc692';
    }
    else if (val > 30 && val <= 40) {
        return '#daa777';
    }
    else if (val > 20 && val <= 30) {
        return '#ca9f5e';
    }
    else if (val > 10 && val <= 20) {
        return '#b0875f';
    }
    else if (val > 0 && val <= 10) {
        return '#9a662d';
    }
    else if (val <= 0 && val > -10) {
        return '#935c00';
    }
    else if (val <= -10 && val > -20) {
        return '#7e4900';
    }
    else if (val <= -20 && val > -30) {
        return '#6a3700';
    }
    else if (val <= -30 && val > -40) {
        return '#5a2f00';
    }
    else if (val <= -40 && val > -50) {
        return '#452300';
    }
    else if (val <= -50 && val > -60) {
        return '#421900';
    }
    else {
        return '#3c0000';
    }
}
